import React, { useParams } from "react-router-dom";
import TefDetails from "./dashboards/info/tefDetails";
import Page1 from "./dashboards/page1";
import AleDetails from "./dashboards/info/aleDetails";
import TlmDetails from "./dashboards/info/tlmDetails";
import ProbaDetails from "./dashboards/info/probaDetails";
import HeatMap from "./dashboards/info/heatmap";
import AssetsDetails from "./dashboards/info/assetsDetails";
import WeaknessDetails from "./dashboards/info/weaknessDetails";
import CostDetails from "./dashboards/info/costDetails";
import DiscoveredAssets from "./dashboards/info/discoveredAssets";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getDashboardData } from "../../redux/actions/dashboardActionCreators";
import { launchTeaserReportAndSave } from "../../redux/actions/organizationProfileCreators";
import TeaserReportConfirm from "../../components/TeaserReportConfirm";
import { useTranslation } from "react-i18next";

export default function PowerBi() {
  const { t } = useTranslation();
  const { page } = useParams();
  const lang = localStorage.getItem("i18nextLng");
  const orgaId =
    useSelector((state) => state.organizationProfile.id) ||
    localStorage.getItem("orgaId");
  const dashboardStatus = useSelector((state) => state.dashboard.status);
  const dashboardMessage = useSelector((state) => state.dashboard.message);
  const dashboardMessageFr = useSelector((state) => state.dashboard.message_fr);
  const dispatch = useDispatch();
  const [teaserReportOpen, setTeaserReportOpen] = useState(false);
  const language = localStorage.getItem("i18nextLng");

  const fetchData = async () => {
    try {
      if (!page) {
        await dispatch(getDashboardData(orgaId, "risk_profile"));
      } else {
        await dispatch(getDashboardData(orgaId, page));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [orgaId, dispatch, page]);

  if (dashboardStatus === "pending") {
    return (
      <Box
        sx={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: { sm: "80vw", xs: "100vw" },
          height: { sm: "30vh", xs: "40vh" },
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 2, sm: 3 },
            px: 2,
            maxWidth: "90%",
            textAlign: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "text.primary",
              fontWeight: 500,
              fontSize: { xs: "1.1rem", sm: "1.25rem" },
              px: 1,
            }}
          >
            {lang === "fr" ? dashboardMessageFr : dashboardMessage}
          </Typography>
          <CircularProgress
            size={80}
            thickness={4}
            sx={{
              color: "primary.main",
              mb: 2,
            }}
          />
        </Box>
      </Box>
    );
  }
  function launchTeaserReportHandler() {
    setTeaserReportOpen(true);
  }

  async function handleTeaserReportConfirm() {
    dispatch(
      launchTeaserReportAndSave({ orga_id: Number(orgaId), confirm: "true" })
    );
    setTeaserReportOpen(false);
    // handleClose();
  }

  if (dashboardStatus === "not_found") {
    return (
      <Box
        sx={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: { sm: "80vw", xs: "100vw" },
          height: { sm: "30vh", xs: "40vh" },
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 2, sm: 3 },
            px: 2,
            maxWidth: "90%",
            textAlign: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              mb: { xs: 2, sm: 3 },
              fontSize: { xs: "0.95rem", sm: "1rem" },
              px: 1,
              maxWidth: { sm: "80%", md: "70%", lg: "60%" },
            }}
          >
            {lang === "fr" ? dashboardMessageFr : dashboardMessage}
          </Typography>
          <Button
            variant="contained"
            color="success"
            size="large"
            onClick={() => {
              launchTeaserReportHandler();
            }}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: { xs: "0.9rem", sm: "1rem" },
              textTransform: "none",
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
              maxWidth: { xs: "280px", sm: "none" },
            }}
          >
            {lang === "fr"
              ? "Lancer le rapport de menace"
              : "Launch Threat Report"}
          </Button>
        </Box>

        <TeaserReportConfirm
          open={teaserReportOpen}
          onClose={() => setTeaserReportOpen(false)}
          onConfirm={handleTeaserReportConfirm}
          message={t("teaser_report_confirm_message")}
          cancelText={t("refuse")}
          confirmText={t("confirm")}
          title={language === "fr" ? "Es-tu sûr?" : "Are you sure?"}
          // onConfirm={handleTeaserReportConfirm}
        />
      </Box>
    );
  }

  switch (page) {
    case "discovered_assets":
      return <DiscoveredAssets />;
    case "cost":
      return <CostDetails />;
    case "weakness":
      return <WeaknessDetails />;
    case "impacted_assets":
      return <AssetsDetails />;
    case "heatmap":
      return <HeatMap />;
    case "proba":
      return <ProbaDetails />;
    case "tlm":
      return <TlmDetails />;
    case "ale":
      return <AleDetails />;
    case "tef":
      return <TefDetails />;
    case "page1":
      return <Page1 />;
    default:
      return <Page1 />; // Default to Page1
  }
}
